import { StorageManager } from '@funtech-int/web-toolkit';

export const PROFILE_SESSION_TIMESTAMP = 'profileSessionTimestamp';
export const IS_PROFILE_FAMILY_CHOICE_SUPPRESSED_KEY = 'profileChoiceBlocked';
export const IS_PROFILE_FAMILY_CHOICE_SUPPRESSED_VALUE = 1;

export const SUBSCRIPTION_PURCHASE_SESSION_TIMESTAMP = 'subscriptionPurchaseSessionTimestamp';

export function updateSubscriptionPurchaseSuppressedSession(storage: StorageManager) {
    const newTimestamp = new Date().getTime();

    storage.local.set(SUBSCRIPTION_PURCHASE_SESSION_TIMESTAMP, String(newTimestamp));
}

export function updateProfileSuppressedSession(storage: StorageManager) {
    const newTimestamp = new Date().getTime();

    storage.local.set(PROFILE_SESSION_TIMESTAMP, String(newTimestamp));
}
